import OverviewPanel from "../../components/overview/OverviewPanel";
import { connect } from "react-redux";
import { AppState } from "src/states/appState";
import { loadOverview } from "src/actions/overviewAction";


const mapStateToProps = (state : AppState)=>({
  ocdbDatasets: state.overviewState.ocdbDatasets,
  fidraddbDatasets: state.overviewState.fidraddbDatasets,
  loading: state.overviewState?.loading,
  error: state.overviewState?.error,
  serverInfo: state.dataState.info
});

export default connect(mapStateToProps,{ loadOverview })(OverviewPanel);